import React, { useState } from 'react';
import styles from '../ReportCard.module.scss';

import MiniMap from '../MiniMap';
import Pagination from './Pagination';
import SearchBar from './SearchBar';
import { isFarFromBase } from '../utils/geo';
import { formatDuration } from '../utils/formatDuration';

/**
 * Модальное окно истории перевозок.
 */
const HistoryModalView = ({
  arrivedBLoads,
  arrivedBCount,
  arrivedBNext,
  arrivedBPrev,
  arrivedBPage,
  setArrivedBPage,
  arrivedBSearch,
  setArrivedBSearch,
  historyLoading,
  historyTableLoading,
  loadHistory,
  onClose,
  user,
}) => {
  const [visibleMaps, setVisibleMaps] = useState({});
  const toggleMap = (id, geoType) => {
    const key = `${id}-${geoType}`;
    setVisibleMaps(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={styles.historyModalContent}>
      <div className={styles.historyModalHeader}>
        <h2 className={styles.historyModalTitle}>История перевозок</h2>
        <button onClick={onClose} className={styles.closeButton}>✕</button>
      </div>
      <div className={styles.historyModalBody}>
        {historyLoading ? (
          <div style={{ padding: '40px', textAlign: 'center', fontSize: '16px' }}>
            <div style={{ marginBottom: '16px' }}>Загрузка истории...</div>
          </div>
        ) : (
          <>
            <SearchBar
              value={arrivedBSearch}
              onChange={setArrivedBSearch}
              onClear={() => { setArrivedBSearch(''); setArrivedBPage(1); }}
              placeholder="Поиск по водителю, телефону, Базе, статусу, номеру машины..."
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (arrivedBPage === 1) loadHistory(false);
                  else setArrivedBPage(1);
                }
              }}
            />

            {/* Индикатор обновления */}
            <div style={{ height: '40px', marginBottom: '8px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {historyTableLoading && (
                <div style={{ padding: '8px', textAlign: 'center', background: '#e7f3ff', borderRadius: '6px', color: '#0d6efd', fontWeight: '500', width: '100%' }}>
                  ⭯ Обновление данных...
                </div>
              )}
            </div>

            <Pagination
              page={arrivedBPage}
              setPage={setArrivedBPage}
              count={arrivedBCount}
              hasNext={!!arrivedBNext}
              hasPrev={!!arrivedBPrev}
              shownCount={arrivedBLoads.length}
            />

            <div style={{ flex: 1, overflowX: 'auto', overflowY: 'auto', minHeight: 0 }}>
              <table className={styles.table_info}>
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Водитель</th>
                    <th>Статус</th>
                    <th>База</th>
                    <th>Номер машины</th>
                    <th>Модель машины</th>
                    <th>Время въезда (Кара-Кече)</th>
                    <th>Время выезда (Кара-Кече)</th>
                    <th>Время погрузки</th>
                    <th>Время прибытия (База)</th>
                    <th>Время доставки</th>
                    <th>Гео Въезд (Кара-Кече)</th>
                    <th>Гео Выезд (Кара-Кече)</th>
                    <th>Гео (База)</th>
                    <th>Отметил въезд</th>
                    <th>Отметил выезд</th>
                    <th>Отметил базу</th>
                    {(user?.is_admin_of || user?.is_report_of) && <th>Фото точки Б</th>}
                    <th>Примечания</th>
                  </tr>
                </thead>
                <tbody>
                  {(Array.isArray(arrivedBLoads) && arrivedBLoads.length > 0) ? arrivedBLoads.map((item, index) => {
                    const isFar = isFarFromBase(item.geo_b, item.geo_base);
                    const sequentialNumber = (arrivedBPage - 1) * 10 + index + 1;

                    return (
                      <tr key={item.id} className={isFar ? styles.dangerRow : ''}>
                        <td data-label="№">{sequentialNumber}</td>
                        <td data-label="Водитель">{item.employee_name || ''} - {item.employee_phone || ''}</td>
                        <td data-label="Статус">{
                          item.status === 'Въехал в точку А'
                            ? 'Въехал в Кара-Кече'
                            : item.status === 'Въехал в точку Б'
                              ? 'Доставил в Базу'
                              : item.status
                        }</td>
                        <td data-label="База">{item.top_base_name || item.chpp_name || item.private_point_name || ''}</td>
                        <td data-label="Номер машины">{item.vehicle_number || '-'}</td>
                        <td data-label="Модель машины">{item.vehicle_model || '-'}</td>
                        <td data-label="Время въезда (Кара-Кече)">{item.time_a}</td>
                        <td data-label="Время выезда (Кара-Кече)">{item.time_a_exit || '-'}</td>
                        <td data-label="Время погрузки">{item.duration_str_loading || '-'}</td>
                        <td data-label="Время прибытия (База)">{item.time_b}</td>
                        <td data-label="Время доставки">{item.duration_str || '-'}</td>
                        <td data-label="Гео Въезд (Кара-Кече)">
                          <GeoCell item={item} geoKey="geo_a" mapKey="geo_a_history" visibleMaps={visibleMaps} toggleMap={toggleMap} />
                        </td>
                        <td data-label="Гео Выезд (Кара-Кече)">
                          <GeoCell item={item} geoKey="geo_a_exit" mapKey="geo_a_exit_history" visibleMaps={visibleMaps} toggleMap={toggleMap} />
                        </td>
                        <td data-label="Гео (База)">
                          <GeoCell item={item} geoKey="geo_b" mapKey="geo_b" visibleMaps={visibleMaps} toggleMap={toggleMap} />
                        </td>
                        <td data-label="Отметил въезд">{item.guard_name || ''}{item.guard_name && item.guard_phone ? ' - ' : ''}{item.guard_phone || ''}</td>
                        <td data-label="Отметил выезд">{item.exit_guard_name || ''}{item.exit_guard_name && item.exit_guard_phone ? ' - ' : ''}{item.exit_guard_phone || ''}</td>
                        <td data-label="Отметил базу">{item.by_guard_name || ''}{item.by_guard_name && item.by_guard_phone ? ' - ' : ''}{item.by_guard_phone || ''}</td>
                        {(user?.is_report_of || user?.is_admin_of) && (
                          <td data-label="Фото точки Б">
                            {item.photo_b ? (
                              <a href={item.photo_b} target="_blank" rel="noopener noreferrer">
                                <img
                                  src={item.photo_b}
                                  alt="Фото транспорта"
                                  style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px', cursor: 'pointer', border: '2px solid #0d6efd' }}
                                  title="Нажмите для просмотра в полном размере"
                                />
                              </a>
                            ) : (
                              <span style={{ color: '#6c757d' }}>-</span>
                            )}
                          </td>
                        )}
                        <td data-label="Примечания">
                          <div style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.notes || ''}>
                            {item.notes || '-'}
                          </div>
                        </td>
                      </tr>
                    );
                  }) : (
                    <tr>
                      <td colSpan={(user?.is_admin_of || user?.is_report_of) ? "19" : "18"} style={{ textAlign: 'center', padding: '20px' }}>
                        Нет данных для отображения
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

/** Ячейка с геолокацией (кнопка Карты + MiniMap) */
const GeoCell = ({ item, geoKey, mapKey, visibleMaps, toggleMap }) => {
  const geoValue = item[geoKey];
  const fullMapKey = `${item.id}-${mapKey}`;
  
  if (!geoValue) {
    return <span>-</span>;
  }
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button
          onClick={() => window.open(`https://www.google.com/maps?q=${geoValue}`, '_blank')}
          className={styles.geoLinkBtn}
          title="Открыть в Google Maps"
        >
          Карты
        </button>
        <button
          onClick={() => toggleMap(item.id, mapKey)}
          className={styles.mapToggleBtn}
          title="Показать/скрыть карту"
        >
          {visibleMaps[fullMapKey] ? '🗺️' : '📌'}
        </button>
      </div>
      {visibleMaps[fullMapKey] && <MiniMap geo={geoValue} />}
    </div>
  );
};

export default React.memo(HistoryModalView);
